import { render, staticRenderFns } from "./payment-status.vue?vue&type=template&id=b2fb9d22&scoped=true"
import script from "./payment-status.vue?vue&type=script&lang=js"
export * from "./payment-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fb9d22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2fb9d22')) {
      api.createRecord('b2fb9d22', component.options)
    } else {
      api.reload('b2fb9d22', component.options)
    }
    module.hot.accept("./payment-status.vue?vue&type=template&id=b2fb9d22&scoped=true", function () {
      api.rerender('b2fb9d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment-status/payment-status.vue"
export default component.exports